<template>
    <TopNav></TopNav>
    <h1>Часова разлика</h1>
    <fieldset>
        <legend>Часова разлика</legend>
        <label for="firstHour">Начален:</label><input type="time" id="firstHour" v-model="firstHour">
        <br>
        <label for="lastHour">Краен:</label><input type="time" id="lastHour" v-model="lastHour">
        <br>
        Разлика: <span class="blue">{{ saatFarki() }}</span>
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: 'HoursDifference',
    data() {
        return {
            firstHour: "00:00",
            lastHour: "00:00"
        }
    },
    components: {
        TopNav
    },
    methods: {
        saatFarki: function () {
            let ilkSaat = this.firstHour.split(":");
            let ilkSaatArray = ilkSaat.map(Number);
            var ilkSaatToplamDakika = ilkSaatArray[0] * 60 + ilkSaatArray[1];

            let sonSaat = this.lastHour.split(":");
            let sonSaatArray = sonSaat.map(Number);
            var sonSaatToplamDakika = sonSaatArray[0] * 60 + sonSaatArray[1];

            var fark;
            var farkSaat;
            var farkDakika;
            if (sonSaatToplamDakika >= ilkSaatToplamDakika) {
                fark = sonSaatToplamDakika - ilkSaatToplamDakika;
            } else {
                let gunSonuFarki = 24 * 60 - ilkSaatToplamDakika;
                fark = gunSonuFarki + sonSaatToplamDakika
            }
            farkSaat = fark / 60;
            farkDakika = fark % 60;

            return parseInt(farkSaat) + ":" + farkDakika;
        },
    },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label {
    display: inline-block;
    width: 110px;
}

footer section a {
    margin: 20px;
}

.blue {
    color: blue;
}
</style>
